import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getBranches } from "../../store/about/aboutAction";
import Loader from "../../component/Loader";
import { Link } from "react-router-dom";
import bg from "../../assets/main/5.jpg";
import img1 from "../../assets/main/1.jpg";
import img2 from "../../assets/main/2.jpg";
import img3 from "../../assets/main/3.jpg";
import img4 from "../../assets/main/4.jpg";
import img5 from "../../assets/main/5.jpg";
import img6 from "../../assets/main/6.jpg";

const Events = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lan = useSelector((state) => state.LanSlicer.language);
  const { branches, loading } = useSelector((state) => state.aboutSlicer);

  useEffect(() => {
    dispatch(getBranches(lan));
  }, [dispatch, lan]);

  return (
    <Fragment>
      <section
        class="flat-title-page back-ground-style"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="breadcrumbs text-center link-style-5 text-white">
              <h2 class="section-title-page">Our Services</h2>
              <ul class="breadcrumbs-inner list-center display-flex">
                <li>
                  <a
                    class="section-16px-regular font-weight-500"
                    href="index.html"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <h4 class="section-16px-regular font-weight-500">
                    Our Services
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section class="flat-list-services">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div
                class="list-services-box grow-up-hover wow fadeInUp"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                <div class="post-services">
                  <img src={img1} class="grow-up-hover" alt="images" />
                  <div class="icon-item-services">
                    <span class="icon-services icon-ux-interface1 font-size-icon active"></span>
                  </div>
                </div>
                <div class="content-services">
                  <div class="content-services-inner">
                    <a
                      href="service-single.html"
                      class="section-20px-montserrat"
                    >
                      UX/UI Design
                    </a>
                    <p class="section-17px-regular margin-top-10">
                      Etiam efficitur, metus in cursus imperdiet, neque nisl
                      porta erat, nec volutpat felis lacus a tellus.
                    </p>
                  </div>
                  <div class="button-readmore">
                    <Link to={"/singleEvent"} class="read-more">
                      Service Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="list-services-box grow-up-hover wow fadeInUp"
                data-wow-delay="300ms"
                data-wow-duration="1500ms"
              >
                <div class="post-services">
                  <img src={img2} class="grow-up-hover" alt="images" />
                  <div class="icon-item-services">
                    <span class="icon-services icon-web-design1 font-size-icon active"></span>
                  </div>
                </div>
                <div class="content-services">
                  <div class="content-services-inner">
                    <a
                      href="service-single.html"
                      class="section-20px-montserrat"
                    >
                      Web Design
                    </a>
                    <p class="section-17px-regular margin-top-10">
                      Etiam efficitur, metus in cursus imperdiet, neque nisl
                      porta erat, nec volutpat felis lacus a tellus.
                    </p>
                  </div>
                  <div class="button-readmore">
                    <Link to={"/singleEvent"} class="read-more">
                      Service Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="list-services-box grow-up-hover wow fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div class="post-services">
                  <img src={img3} class="grow-up-hover" alt="images" />
                  <div class="icon-item-services">
                    <span class="icon-services icon-web-programming1 font-size-icon active"></span>
                  </div>
                </div>
                <div class="content-services">
                  <div class="content-services-inner">
                    <a
                      href="service-single.html"
                      class="section-20px-montserrat"
                    >
                      Web Development
                    </a>
                    <p class="section-17px-regular margin-top-10">
                      Etiam efficitur, metus in cursus imperdiet, neque nisl
                      porta erat, nec volutpat felis lacus a tellus.
                    </p>
                  </div>
                  <div class="button-readmore">
                    <Link to={"/singleEvent"} class="read-more">
                      Service Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="list-services-box grow-up-hover wow fadeInUp"
                data-wow-delay="0ms"
                data-wow-duration="1500ms"
              >
                <div class="post-services">
                  <img src={img4} class="grow-up-hover" alt="images" />
                  <div class="icon-item-services">
                    <span class="icon-services icon-setting1 font-size-icon active"></span>
                  </div>
                </div>
                <div class="content-services">
                  <div class="content-services-inner">
                    <a
                      href="service-single.html"
                      class="section-20px-montserrat"
                    >
                      Software Development
                    </a>
                    <p class="section-17px-regular margin-top-10">
                      Etiam efficitur, metus in cursus imperdiet, neque nisl
                      porta erat, nec volutpat felis lacus a tellus.
                    </p>
                  </div>
                  <div class="button-readmore">
                    <Link to={"/singleEvent"} class="read-more">
                      Service Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="list-services-box grow-up-hover wow fadeInUp"
                data-wow-delay="300ms"
                data-wow-duration="1500ms"
              >
                <div class="post-services">
                  <img src={img5} class="grow-up-hover" alt="images" />
                  <div class="icon-item-services">
                    <span class="icon-services icon-advertising1 font-size-icon active"></span>
                  </div>
                </div>
                <div class="content-services">
                  <div class="content-services-inner">
                    <a
                      href="service-single.html"
                      class="section-20px-montserrat"
                    >
                      Digital Marketing
                    </a>
                    <p class="section-17px-regular margin-top-10">
                      Etiam efficitur, metus in cursus imperdiet, neque nisl
                      porta erat, nec volutpat felis lacus a tellus.
                    </p>
                  </div>
                  <div class="button-readmore">
                    <Link to={"/singleEvent"} class="read-more">
                      Service Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div
                class="list-services-box grow-up-hover wow fadeInUp"
                data-wow-delay="600ms"
                data-wow-duration="1500ms"
              >
                <div class="post-services">
                  <img src={img6} class="grow-up-hover" alt="images" />
                  <div class="icon-item-services">
                    <span class="icon-services icon-cellphone1 font-size-icon active"></span>
                  </div>
                </div>
                <div class="content-services">
                  <div class="content-services-inner">
                    <a
                      href="service-single.html"
                      class="section-20px-montserrat"
                    >
                      Apps Development
                    </a>
                    <p class="section-17px-regular margin-top-10">
                      Etiam efficitur, metus in cursus imperdiet, neque nisl
                      porta erat, nec volutpat felis lacus a tellus.
                    </p>
                  </div>
                  <div class="button-readmore">
                    <Link to={"/singleEvent"} class="read-more">
                      Service Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="flat-about-work">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-5">
              <div class="about-work-post wow fadeInLeft">
                <img src={img1} alt="images" />
              </div>
            </div>
            <div class="col-md-7">
              <div class="about-work-content wow fadeInUp">
                <h4 class="section-subtitle">How i work</h4>
                <h2 class="section-45px-montserrat margin-top-15 margin-bottom-12">
                  How Do We Create Better Products
                </h2>
                <p class="section-17px-regular margin-bottom-58">
                  Etiam efficitur, metus in cursus imperdiet, neque nisl porta
                  erat, nec volutpat felis lacus a tellus. Nunc tristique nulla
                  nisi, a viverra dui auctor vitae. Vestibulum mollis commodo
                  leo in hendrerit. Nam convallis ac lacus luctus vestibulum.
                  Donec cursus tellus id neque convallis blandit.
                </p>
                <a
                  href="https://www.youtube.com/embed/xC4ze0p0b5Y"
                  class="lightbox-image"
                >
                  <div class="icon">
                    <i class="ripple"></i>
                  </div>
                </a>
                <div class="button-readmore link-style-5 wow fadeInDown">
                  <Link to={"/home"} class="read-more">
                    See how we work
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Events;
